import api from '../../lib/api';
import type {
  EvaluationPayload,
  ExpiryAlertPreviewItem,
  LegalComplianceEvaluation,
  LegalRequirementDetail,
  LegalRequirementPayload,
  PaginatedLegalRequirements,
} from './types';

export interface ListLegalRequirementsParams {
  page?: number;
  pageSize?: number;
  type?: string;
  status?: string;
  processArea?: string;
  search?: string;
  active?: boolean;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const fetchLegalRequirements = async (
  params: ListLegalRequirementsParams = {},
): Promise<PaginatedLegalRequirements> => {
  const { data } = await api.get<PaginatedLegalRequirements>('legal-requirements', { params });
  return data;
};

export const fetchLegalRequirement = async (id: string): Promise<LegalRequirementDetail> => {
  const { data } = await api.get<LegalRequirementDetail>(`legal-requirements/${id}`);
  return data;
};

export const createLegalRequirement = async (payload: LegalRequirementPayload) => {
  const { data } = await api.post('legal-requirements', payload);
  return data;
};

export const updateLegalRequirement = async (id: string, payload: Partial<LegalRequirementPayload>) => {
  const { data } = await api.put(`legal-requirements/${id}`, payload);
  return data;
};

export const deactivateLegalRequirement = async (id: string) => {
  const { data } = await api.delete(`legal-requirements/${id}`);
  return data;
};

export const createEvaluation = async (
  requirementId: string,
  payload: EvaluationPayload,
): Promise<LegalComplianceEvaluation> => {
  const { data } = await api.post<LegalComplianceEvaluation>(
    `legal-requirements/${requirementId}/evaluations`,
    payload,
  );
  return data;
};

export const escalateEvaluationToNc = async (
  evalId: string,
): Promise<{ evaluation: LegalComplianceEvaluation; qmsRecordId: string }> => {
  const { data } = await api.post<{ evaluation: LegalComplianceEvaluation; qmsRecordId: string }>(
    `legal-requirements/evaluations/${evalId}/to-nc`,
  );
  return data;
};

export const fetchExpiryAlertsPreview = async (): Promise<{
  evaluatedAt: string;
  total: number;
  items: ExpiryAlertPreviewItem[];
}> => {
  const { data } = await api.get<{
    evaluatedAt: string;
    total: number;
    items: ExpiryAlertPreviewItem[];
  }>('legal-requirements/alerts/preview');
  return data;
};
